/* === Countdown Coupon block logic === B */
(() => {
    const SELECTOR = '[data-count-down]'

    const normalizeDateString = (value) => {
      if (!value) return value
      const trimmed = String(value).trim()
      if (/^\d{4}-\d{2}-\d{2}\s+\d{2}:\d{2}(:\d{2})?$/.test(trimmed)) {
        return trimmed.replace(/\s+/, 'T')
      }
      return trimmed
    }

    const startCountdown = (element, dateString) => {
      const targetDate = new Date(normalizeDateString(dateString))

      if (Number.isNaN(targetDate.getTime())) {
        console.error('Invalid date format:', dateString)
        return
      }

      const endsInText = element.getAttribute('data-ends-in') || 'Ends in'
      const daysTitle = element.getAttribute('data-days-title') || 'Days'

      const updateCountdown = () => {
        const now = Date.now()
        const distance = targetDate.getTime() - now

        if (distance < 0) {
          element.textContent = 'Expired'
          if (element.countdownInterval) {
          clearInterval(element.countdownInterval)
          element.countdownInterval = null
        }
          return
        }

        const days = Math.floor(distance / (1000 * 60 * 60 * 24))
        const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        const seconds = Math.floor((distance % (1000 * 60)) / 1000)

        const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes
          .toString()
          .padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`

        element.textContent =
          days > 0 ? `${endsInText} ${days} ${daysTitle} ${formattedTime}` : `${endsInText} ${formattedTime}`
      }

      updateCountdown()

      if (element.countdownInterval) {
        clearInterval(element.countdownInterval)
      }

      element.countdownInterval = window.setInterval(updateCountdown, 1000)
    }

    const initCountdown = (root = document) => {
      const countdownElements = root.querySelectorAll(SELECTOR)
      if (!countdownElements.length) return

      countdownElements.forEach((element) => {
        const countdownText = element.getAttribute('data-count-down')
        if (countdownText) startCountdown(element, countdownText)
      })
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initCountdown())
    } else {
      initCountdown()
    }

    document.addEventListener('shopify:section:load', (event) => {
      if (event?.target) initCountdown(event.target)
    })
  })()
/* === Countdown Coupon block logic === E */

document.addEventListener('DOMContentLoaded', () => {

    /* === Sticky buy button add class name logic === B */
    const root = document.querySelector('.product-container[data-section-id]');
    const sectionId = root?.dataset.sectionId;
    const target = sectionId
    ? document.querySelector(`[data-section-id="${sectionId}"] .custom-sticky-form__wrapper`)
    : null;
    if (!target) return;

    const stickyForm = target.querySelector('.product-form__controls-group--submit');
    const desktopMediaQuery = window.matchMedia('(min-width: 750px)');
    const visibilityThreshold = 0.3;
    let isMeasuringStickySpace = false;

    // Desktop sticky uses `:not(.is-showing) { position: fixed }`, which removes the
    // form from document flow. Without a reserved height the observed wrapper collapses
    // to 0px and repeatedly crosses the 30% IntersectionObserver threshold.
    const reserveStickyFormSpace = () => {
      if (isMeasuringStickySpace) return;

      if (!stickyForm || !desktopMediaQuery.matches) {
        target.style.minHeight = '';
        return;
      }

      isMeasuringStickySpace = true;

      // Prefer measuring the form itself: wrapper minHeight must not inflate the reading.
      // When sticky (fixed), briefly restore in-flow so we capture document-flow height,
      // not the sticky chrome height (different children are shown/hidden).
      if (!target.classList.contains('is-showing')) {
        target.classList.add('is-showing');
        target.style.minHeight = `${stickyForm.getBoundingClientRect().height}px`;
        target.classList.remove('is-showing');
      } else {
        target.style.minHeight = `${stickyForm.getBoundingClientRect().height}px`;
      }

      isMeasuringStickySpace = false;
    };

    reserveStickyFormSpace();

    if ('ResizeObserver' in window && stickyForm) {
      const formResizeObserver = new ResizeObserver(() => {
        // Only sync from live layout while in-flow; sticky (fixed) height differs.
        if (!desktopMediaQuery.matches || !target.classList.contains('is-showing')) return;
        reserveStickyFormSpace();
      });

      formResizeObserver.observe(stickyForm);
    }

    let resizeFrame;
    const scheduleReserveStickyFormSpace = () => {
      cancelAnimationFrame(resizeFrame);
      resizeFrame = requestAnimationFrame(reserveStickyFormSpace);
    };

    window.addEventListener('resize', scheduleReserveStickyFormSpace);

    if (typeof desktopMediaQuery.addEventListener === 'function') {
      desktopMediaQuery.addEventListener('change', scheduleReserveStickyFormSpace);
    } else if (typeof desktopMediaQuery.addListener === 'function') {
      desktopMediaQuery.addListener(scheduleReserveStickyFormSpace);
    }

    let timeout;
    const observer = new IntersectionObserver(
    (entries) => {
        entries.forEach(entry => {
        // threshold alone only controls when the callback fires; isIntersecting is true
        // for any visible pixel, so gate on the actual ratio to avoid sticky flicker.
        if (entry.isIntersecting && entry.intersectionRatio >= visibilityThreshold) {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
            entry.target.classList.add('is-showing');
            }, 100);
        } else {
            clearTimeout(timeout);
            entry.target.classList.remove('is-showing');
        }
        });
    },
    { threshold: visibilityThreshold }
    );

    observer.observe(target);
    /* === Sticky buy button add class name logic === E */

    /* === PayPal box logic === B */
    const paypalBox = document.querySelector('.PayPal_box');
    const paypal_method_btn = document.querySelector('.paypal_method .paypal_text');
    const closeBtn = paypalBox.querySelector('.close_btn');
    if(paypal_method_btn){
      paypal_method_btn.addEventListener('click', (e) => {
        e.preventDefault();
        if (paypalBox) {
          paypalBox.classList.add('active');
        }
      });
    }
    closeBtn.addEventListener('click', () => {
      if (paypalBox) {
        paypalBox.classList.remove('active');
      }
    });
    /* === PayPal box logic === E */

    /* === Klarna badge logic === B */
    const targetElement = document.querySelector('.product-form klarna-placement[data-key="credit-promotion-badge"]');
    if (targetElement.shadowRoot) {
      const style = document.createElement('style')
      style.textContent = `
      .badge svg {
        width: 40px;
        height: 24px;
      }
      .text-wrapper {
        margin-left: 6px;
      }
      .link {
        color: #0070ba;
        font-family: Helvetica, Arial, sans-serif;
        line-height: 19px;
      }
      .text-wrapper .text {
        font-family: Helvetica, Arial, sans-serif;
        line-height: 19px;
        color: rgb(44, 46, 47);
      }
      .container  {
        border-radius: 4px;
      }
      @media screen and (max-width: 768px) {
        .link {
          font-size: 12px;
        }
        .text-wrapper .text {
          font-size: 12px;
        }
      }`
      targetElement.shadowRoot.appendChild(style)
    }
    /* === Klarna badge logic === E */

    /* === Install block logic === B */
    const installBlocks = document.querySelectorAll('.install-block .install-checkbox')
    installBlocks.forEach(block => {
        block.addEventListener('click', () => {
        const classList = block.parentNode.classList
        if (classList.contains('disabled')) return

        const isChecked = classList.contains('checked')
        const checkbox = block.querySelector('.install-checkbox_input')
        checkbox.checked = !isChecked
        var priceElement = document.querySelector('.product-form__controls-group--submit .price-wrapper');
        var orig_regular_price = priceElement.getAttribute('data-price');
        var orig_compare_price = priceElement.getAttribute('data-compare-price');
        var orig_saving = priceElement.getAttribute('data-saving');
        var priceFormat = theme.priceCurrencyCodeEnable ? theme.moneyFormatWithCurrency : theme.moneyFormat;
        var price = block.parentNode.getAttribute('data-price');
        var compare_price = block.parentNode.getAttribute('data-compare-price');
        var comparePriceFormat = theme.comparePriceCurrencyCodeEnable ? theme.moneyFormatWithCurrency : theme.moneyFormat;
        if (isChecked) {
            var saving = compare_price - price;
            orig_regular_price = parseInt(orig_regular_price) - parseInt(price);
            orig_compare_price = parseInt(orig_compare_price) - parseInt(compare_price);
            orig_saving = parseInt(orig_saving) - parseInt(saving);
            classList.remove('checked')
        } else {
            var saving = compare_price - price;
            orig_regular_price = parseInt(orig_regular_price) + parseInt(price);
            orig_compare_price = parseInt(orig_compare_price) + parseInt(compare_price);
            orig_saving = parseInt(orig_saving) + parseInt(saving);
            classList.add('checked')
        }
        priceElement.dataset.price = orig_regular_price
        priceElement.dataset.comparePrice = orig_compare_price
        priceElement.dataset.saving = orig_saving
        if(document.querySelector('.sticky-price-wrapper .product-price')){
            document.querySelector('.sticky-price-wrapper .product-price').innerHTML = formatMoney(orig_regular_price, priceFormat).replace(/\./g, ' ');
        }

        priceElement.querySelector('.regular-price').innerHTML = formatMoney(orig_regular_price, priceFormat).replace(',00','').replace(/\./g, ' ');
        if(orig_compare_price > 0){
            priceElement.querySelector('.compare-price').innerHTML = formatMoney(orig_compare_price, theme.moneyFormat).replace(',00','').replace(/\./g, ' ');
            priceElement.querySelector('.compare-price').style.display = 'block';
        }
        else{
            priceElement.querySelector('.compare-price').style.display = 'none';
        }
        if(orig_saving > 0){
            priceElement.querySelector('.total-savings').innerHTML = '-' + formatMoney(orig_saving, comparePriceFormat).replace(',00','').replace(/\./g, ' ');
            priceElement.querySelector('.total-savings').style.display = 'block';
        }
        else{
            priceElement.querySelector('.total-savings').style.display = 'none';
        }
        })
    })

    function formatMoney(cents, format) {
        if (typeof cents === 'string') {
        cents = cents.replace('.', '');
        }
        var value = '';
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || moneyFormat;

        function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ',';
        decimal = decimal || '.';

        if (isNaN(number) || number === null) {
            return 0;
        }

        number = (number / 100.0).toFixed(precision);

        var parts = number.split('.');
        var dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            '$1' + thousands
        );
        var centsAmount = parts[1] ? decimal + parts[1] : '';

        return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
        case 'amount_no_decimals_with_space_separator':
            value = formatWithDelimiters(cents, 0, ' ');
            break;
        case 'amount_with_apostrophe_separator':
            value = formatWithDelimiters(cents, 2, "'");
            break;
        }

        return formatString.replace(placeholderRegex, value);
    }


    const workTriggers = document.querySelectorAll(".install-content-richtext a[href='#install-content-work_trigger']")
    console.log('workTrigger', workTriggers)
    console.log('workworkTriggerworkTriggerwworkTriggerworkTriggerorkTriggerworkTriggerworkTriggerworkTriggerTrigger')
    workTriggers.forEach(trigger => {
        trigger.addEventListener('click', () => {
        console.log('click')
        const mask = document.querySelector('.install-work-popup-mask')
        const popup = document.querySelector('.install-work-popup')
        const maskClone = mask.cloneNode(true)
        const popupClone = popup.cloneNode(true)
        maskClone.classList.add('body-child')
        popupClone.classList.add('body-child')
        document.body.appendChild(maskClone)
        document.body.appendChild(popupClone)
        document.body.style.overflow = 'hidden'

        const closeBtn = popupClone.querySelector('.install-close_btn')
        closeBtn.addEventListener('click', () => {
            maskClone.remove()
            popupClone.remove()
            document.body.style.overflow = 'auto'
            window.history.pushState("", document.title, window.location.pathname + window.location.search);
        })
        })
    })
    /* === Install block logic === E */

});
